module.exports = __webpack_public_path__ + "_assets/img/pGoogle.284ee9c0.svg";